export default "__VITE_ASSET__DG_OmWuT__"